// Color type - either/or
export const COLOR_TYPES = ['Black/Grey', 'Color'];

// Size - single select
export const SIZES = ['Small', 'Medium', 'Large'];

// Artist ink specialty - single select (optional)
export const INK_SPECIALTIES = ['Black/Grey Specialty', 'Color Specialty', 'I Do Both Equally'];

// Artist design specialty - single select (required for artists)
export const DESIGN_SPECIALTIES = ['Flash Specialty', 'Custom Specialty', 'I Do Both Equally'];

// Style - up to 2 (combines former Foundational Style + Technique/Finish)
export const STYLES = [
  'Traditional',
  'New School',
  'Lettering',
  'Realism',
  'Illustrative',
  'Tribal',
  'Geometric',
  'Neo-Traditional',
  'Japanese',
  'Surrealism',
  'Blackwork',
  'Minimalist',
  'Fine Line',
  'Dotwork',
  'Watercolor',
  'Chicano',
  'Sketch',
];

// Subject - up to 2
export const SUBJECTS = [
  'Animal',
  'Floral',
  'Nature',
  'Portrait',
  'Lettering',
  'Fantasy',
  'Sci-fi',
  'Nautical',
  'Pop Culture',
  'Cartoon',
  'Dark',
  'Decorative',
  'Spiritual',
  'Abstract',
  'Psychedelic',
  'Traditional Imagery',
];
